module.exports = __webpack_public_path__ + "media/bg/bg-4-832a4d3f.jpg";